import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'

export const PlayIcon =
    'https://res.cloudinary.com/dfxsbjglg/image/upload/v1646353660/viddy/play.svg'
export const MutedIcon =
    'https://res.cloudinary.com/dfxsbjglg/image/upload/v1646353660/viddy/muted.svg'
export const UnmutedIcon =
    'https://res.cloudinary.com/dfxsbjglg/image/upload/v1646353660/viddy/unmuted.svg'
export const DownIcon =
    'https://res.cloudinary.com/dfxsbjglg/image/upload/v1646353660/viddy/down.svg'
export const CloseIcon =
    'https://res.cloudinary.com/dfxsbjglg/image/upload/v1646353660/viddy/close-x.svg'

const whiteSpinKeyframes = () => keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
export const PlayBtn = () => {
    return (
        <svg
            width={30}
            height={30}
            viewBox="0 0 95 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.5147 93.5693C11.592 93.9653 12.8043 94.2293 14.0165 94.2293C15.902 94.2293 17.7876 93.5693 19.4036 92.5133L86.0703 57.0038L86.7436 56.3438C88.4945 54.6278 89.4371 52.5155 89.4371 50.1395C89.4371 47.7635 88.4945 45.5193 86.7436 43.9353L86.0703 43.2753L19.4036 7.50176C16.9794 5.65376 13.4776 5.25777 10.5147 6.44577C7.14759 7.76577 4.99292 11.066 4.99292 14.6302V85.3851C4.9927 88.9493 7.14759 92.2493 10.5147 93.5693Z"
                fill="white"
                stroke="white"
                strokeWidth="10"
                strokeMiterlimit="10"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const LockIcon = ({ color = '#fff' }: { color?: string }) => {
    return (
        <span
            style={{
                marginRight: '0.5em',
                marginTop: 0,
                display: 'inline-flex',
                flexShrink: 0,
            }}
        >
            <svg
                width="1.375em"
                height="1.375em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288"
                    stroke={color}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </span>
    )
}

export const ButtonLoadingSpinner: React.FC<{ color?: string }> = ({
    color = '#fff',
}) => {
    return (
        <svg
            fill={color}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z">
                <animateTransform
                    attributeName="transform"
                    type="rotate"
                    dur="0.75s"
                    values="0 12 12;360 12 12"
                    repeatCount="indefinite"
                />
            </path>
        </svg>
    )
}

export const WhiteSpinner = styled.div({
    display: 'inline-block',
    width: 80,
    height: 80,
    ':after': {
        content: '" "',
        display: 'block',
        width: 64,
        height: 64,
        margin: 8,
        borderRadius: '50%',
        border: '6px solid #fff',
        borderColor: '#fff transparent #fff transparent',
        animation: `${whiteSpinKeyframes()} 1.2s linear infinite`,
    },
})

export const UpArrow: React.FC<{ mb?: number; height?: number }> = ({
    mb,
    height,
}) => {
    return (
        <svg
            style={{ marginBottom: mb ? mb : 0 }}
            fill="#fff"
            height={height || 15}
            width={height || 15}
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 511.735 511.735"
        >
            <g>
                <g>
                    <path
                        d="M508.788,371.087L263.455,125.753c-4.16-4.16-10.88-4.16-15.04,0L2.975,371.087c-4.053,4.267-3.947,10.987,0.213,15.04
    c4.16,3.947,10.667,3.947,14.827,0l237.867-237.76l237.76,237.76c4.267,4.053,10.987,3.947,15.04-0.213
    C512.734,381.753,512.734,375.247,508.788,371.087z"
                    />
                </g>
            </g>
        </svg>
    )
}

/** Chevron drawn in `currentColor`, for arrows that sit on a disc of their own. */
export const CarouselChevron: React.FC<{
    width: number
    direction: 'left' | 'right'
}> = ({ width, direction }) => (
    <svg
        width={width}
        height={width}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
            transform: direction === 'left' ? 'rotate(180deg)' : undefined,
        }}
    >
        <path
            d="M9 5l7 7-7 7"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TrashIcon: React.FC<{
    width: number
    onClick?: React.MouseEventHandler
    disabled?: boolean
    color: string
    disabledColor: string
}> = ({ width, onClick, disabled, color, disabledColor }) => {
    return (
        <div
            onClick={disabled ? undefined : onClick}
            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
        >
            <svg
                width={width}
                height="30px"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M20.5001 6H3.5"
                    stroke={disabled ? disabledColor : color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                    stroke={disabled ? disabledColor : color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M9.5 11L10 16"
                    stroke={disabled ? disabledColor : color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M14.5 11L14 16"
                    stroke={disabled ? disabledColor : color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
                <path
                    d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6"
                    stroke={disabled ? disabledColor : color}
                    strokeWidth="1.5"
                />
            </svg>
        </div>
    )
}

export const ExternalLink: React.FC<{ width?: number; color?: string }> = ({
    width = 30,
    color = '#000',
}) => {
    return (
        <svg
            width={width}
            height={'30px'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18 20.75H6C5.27065 20.75 4.57118 20.4603 4.05546 19.9445C3.53973 19.4288 3.25 18.7293 3.25 18V6C3.25 5.27065 3.53973 4.57118 4.05546 4.05546C4.57118 3.53973 5.27065 3.25 6 3.25H12C12.1989 3.25 12.3897 3.32902 12.5303 3.46967C12.671 3.61032 12.75 3.80109 12.75 4C12.75 4.19891 12.671 4.38968 12.5303 4.53033C12.3897 4.67098 12.1989 4.75 12 4.75H6C5.66848 4.75 5.35054 4.8817 5.11612 5.11612C4.8817 5.35054 4.75 5.66848 4.75 6V18C4.75 18.3315 4.8817 18.6495 5.11612 18.8839C5.35054 19.1183 5.66848 19.25 6 19.25H18C18.3315 19.25 18.6495 19.1183 18.8839 18.8839C19.1183 18.6495 19.25 18.3315 19.25 18V12C19.25 11.8011 19.329 11.6103 19.4697 11.4697C19.6103 11.329 19.8011 11.25 20 11.25C20.1989 11.25 20.3897 11.329 20.5303 11.4697C20.671 11.6103 20.75 11.8011 20.75 12V18C20.75 18.7293 20.4603 19.4288 19.9445 19.9445C19.4288 20.4603 18.7293 20.75 18 20.75Z"
                fill={color}
            />
            <path
                d="M20 8.75C19.8019 8.74741 19.6126 8.66756 19.4725 8.52747C19.3324 8.38737 19.2526 8.19811 19.25 8V4.75H16C15.8011 4.75 15.6103 4.67098 15.4697 4.53033C15.329 4.38968 15.25 4.19891 15.25 4C15.25 3.80109 15.329 3.61032 15.4697 3.46967C15.6103 3.32902 15.8011 3.25 16 3.25H20C20.1981 3.25259 20.3874 3.33244 20.5275 3.47253C20.6676 3.61263 20.7474 3.80189 20.75 4V8C20.7474 8.19811 20.6676 8.38737 20.5275 8.52747C20.3874 8.66756 20.1981 8.74741 20 8.75Z"
                fill={color}
            />
            <path
                d="M13.5 11.25C13.3071 11.2352 13.1276 11.1455 13 11C12.877 10.8625 12.809 10.6845 12.809 10.5C12.809 10.3155 12.877 10.1375 13 10L19.5 3.5C19.5687 3.42631 19.6515 3.36721 19.7435 3.32622C19.8355 3.28523 19.9348 3.26319 20.0355 3.26141C20.1362 3.25963 20.2362 3.27816 20.3296 3.31588C20.423 3.3536 20.5078 3.40974 20.579 3.48096C20.6503 3.55218 20.7064 3.63701 20.7441 3.7304C20.7818 3.82379 20.8004 3.92382 20.7986 4.02452C20.7968 4.12523 20.7748 4.22454 20.7338 4.31654C20.6928 4.40854 20.6337 4.49134 20.56 4.56L14 11C13.8724 11.1455 13.6929 11.2352 13.5 11.25Z"
                fill={color}
            />
        </svg>
    )
}

export const GridIcon: React.FC<{
    width?: number
    height?: number
    color?: string
}> = ({ width = 24, height = 24, color = 'currentColor' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="6" y="6" width="5" height="5" rx="0.5" fill={color} />
            <rect x="13" y="6" width="5" height="5" rx="0.5" fill={color} />
            <rect x="6" y="13" width="5" height="5" rx="0.5" fill={color} />
            <rect x="13" y="13" width="5" height="5" rx="0.5" fill={color} />
        </svg>
    )
}

export const ListIcon: React.FC<{
    width?: number
    height?: number
    color?: string
}> = ({ width = 24, height = 24, color = 'currentColor' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="5" y="6" width="14" height="2" rx="1" fill={color} />
            <rect x="5" y="11" width="14" height="2" rx="1" fill={color} />
            <rect x="5" y="16" width="14" height="2" rx="1" fill={color} />
        </svg>
    )
}

export const CartIcon: React.FC<{
    size?: number
    color?: string
}> = ({ size = 20, color = 'currentColor' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 29"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.59806 9.7874C7.81536 9.7874 7.17143 10.4313 7.17143 11.214V20.3445C7.17143 21.1272 7.81536 21.7711 8.59806 21.7711H20.0111C20.7938 21.7711 21.4377 21.1272 21.4377 20.3445V11.214C21.4377 10.4313 20.7938 9.7874 20.0111 9.7874H8.59806ZM5.45947 11.214C5.45947 9.48585 6.86989 8.07544 8.59806 8.07544H20.0111C21.7393 8.07544 23.1497 9.48585 23.1497 11.214V20.3445C23.1497 22.0726 21.7393 23.483 20.0111 23.483H8.59806C6.86989 23.483 5.45947 22.0726 5.45947 20.3445V11.214Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.0244 7.79015C10.0244 5.37719 11.8913 3.51025 14.3043 3.51025C16.7173 3.51025 18.5842 5.37719 18.5842 7.79015V11.7847C18.5842 12.2574 18.2009 12.6407 17.7282 12.6407C17.2555 12.6407 16.8722 12.2574 16.8722 11.7847V7.79015C16.8722 6.32267 15.7718 5.22221 14.3043 5.22221C12.8368 5.22221 11.7364 6.32267 11.7364 7.79015V11.7847C11.7364 12.2574 11.3531 12.6407 10.8804 12.6407C10.4077 12.6407 10.0244 12.2574 10.0244 11.7847V7.79015Z"
                fill={color}
            />
        </svg>
    )
}

export const ShoppingCartIcon: React.FC<{
    size?: number
    color?: string
}> = ({ size = 20, color = 'currentColor' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 29"
            fill="none"
            stroke={color}
            strokeWidth={1.7}
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M2.5 5H6L9 18.5H22.5L25.5 8.5H7" />
            <circle cx="10.5" cy="23" r="1.6" />
            <circle cx="21" cy="23" r="1.6" />
        </svg>
    )
}

export const BasketIcon: React.FC<{
    size?: number
    color?: string
}> = ({ size = 20, color = 'currentColor' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 28 29"
            fill="none"
            stroke={color}
            strokeWidth={1.7}
            strokeLinecap="round"
            strokeLinejoin="round"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M9 12C9 7.5 11.2 5 14 5C16.8 5 19 7.5 19 12" />
            <path d="M4.5 12H23.5L21.6 22.2C21.4 23.3 20.5 24 19.4 24H8.6C7.5 24 6.6 23.3 6.4 22.2Z" />
        </svg>
    )
}

export const VerifiedBadgeIcon: React.FC<{
    size?: number
    color?: string
}> = ({ size = 14, color = 'currentColor' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="12"
                cy="12"
                r="8"
                stroke={color}
                strokeWidth="2"
                fill="none"
            />
            <path
                d="M8.5 12.5L10.5 14.5L15.5 9.5"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const MutedSpeakerIcon: React.FC<{
    size?: number
    color?: string
}> = ({ size = 18, color = '#FFFFFF' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3.63 3.63a.996.996 0 000 1.41L7.29 8.7 7 9H4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h3l3.29 3.29c.63.63 1.71.18 1.71-.71v-4.17l4.18 4.18c-.49.37-1.02.68-1.6.91-.36.15-.58.53-.58.92 0 .72.73 1.18 1.39.91.8-.33 1.55-.77 2.22-1.31l1.34 1.34a.996.996 0 101.41-1.41L5.05 3.63a.996.996 0 00-1.42 0zM19 12c0 .82-.15 1.61-.41 2.34l1.53 1.53c.56-1.17.88-2.48.88-3.87 0-3.83-2.4-7.11-5.78-8.4-.59-.23-1.22.23-1.22.86v.19c0 .38.25.71.61.85C17.18 6.54 19 9.06 19 12zm-8.71-6.29l-.17.17L12 7.76V6.41c0-.89-1.08-1.33-1.71-.7zM16.5 12c0-1.77-1.02-3.29-2.5-4.03v1.79l2.48 2.48c.01-.08.02-.16.02-.24z" />
        </svg>
    )
}

export const UnmutedSpeakerIcon: React.FC<{
    size?: number
    color?: string
}> = ({ size = 18, color = '#FFFFFF' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
        </svg>
    )
}

export const CheckmarkIcon: React.FC<{
    width?: number
    height?: number
    color?: string
}> = ({ width = 14, height = 14, color = 'currentColor' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 6L9 17L4 12"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const PriceTagIcon: React.FC<{
    width?: number
    height?: number
    color?: string
}> = ({ width = 14, height = 14, color = 'currentColor' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20.59 13.41L13.42 6.24C13.2341 6.05477 13.0007 5.96018 12.76 5.96H6C5.46957 5.96 4.96086 6.17071 4.58579 6.54578C4.21071 6.92086 4 7.42957 4 7.96V14.76C4 15.0007 4.09459 15.2341 4.28 15.42L11.45 22.59C11.6358 22.7758 11.8692 22.8704 12.11 22.8704C12.3508 22.8704 12.5842 22.7758 12.77 22.59L20.59 14.77C20.7758 14.5842 20.8704 14.3508 20.8704 14.11C20.8704 13.8692 20.7758 13.6358 20.59 13.41Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="8" cy="8" r="1.5" fill={color} />
        </svg>
    )
}
